import * as core from '../../../../../../../core'

import { query } from './save-subrecipient.query'

export const RESOURCE = {
  payload: {
    alias: 'sr.save-subrecipient',
    description: 'Save Subrecipient',
    name: 'Save Subrecipient',
    query,
  },
  type: core.quiver.Resource.Type.MosaicAction,
} as const satisfies core.quiver.Resource<core.quiver.Resource.Type.MosaicAction>
